import React from "react";
import styles from "../Dashboard.module.css";

const Certificates = () => {
  return (
    <div className={styles.dashboard}>
      <main className={styles.main}>Certificates</main>
    </div>
  );
};

export default Certificates;
